// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__15eBQ","content":"RecentSearches_content__31zYF"};